import '../../styles/theme.css';

import * as Sentry from '@sentry/browser';

import Accordion from '../components/accordion';
import customDropdown from '../components/custom-dropdown.js';
import pageModal from '../components/page-modal';
import emailOptInSection from '../components/email-opt-in-section';
import env from '../config';

/*================ Sections ================*/
import badgingCarouselSection from '../sections/badgingCarousel.js';
import featureBlogSection from '../sections/blogFeature.js';
import { DropdownSelect } from '../sections/dropdownSelect.js';
import productCompare from '../sections/productCompare.js';
import productHotspot from '../sections/productHotspot.js';
import productUpsell from '../sections/productUpsell.js';
import SiteHeader from '../sections/siteHeader.js';
import storyBlockModal from '../sections/storyBlockModal.js';
import storyCarousel from '../sections/storyCarousel.js';
import { setupObservers } from '../utils/LazyLoad.js';

const handleRedirect = () => {
  const recaptcha = document.getElementById('g-recaptcha');
  if (recaptcha) {
    const submitBtn = document.querySelector(
      '.shopify-challenge__container input[type="submit"]',
    );
    const form = submitBtn.parentElement;
    const returnTo = document.createElement('input');
    returnTo.setAttribute('type', 'hidden');
    returnTo.setAttribute('name', 'return_to');
    let returnUrl = `/account`;
    if (
      document.referrer.includes('contact-us') &&
      location.hash == '#ContactForm'
    ) {
      returnUrl = document.referrer.split('#')[0] + '#ContactForm';
    }
    returnTo.setAttribute('value', returnUrl);
    form.insertBefore(returnTo, submitBtn);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  setupObservers({});
  customDropdown.init();
  DropdownSelect();
  Accordion.init();
  SiteHeader.init();
  storyBlockModal.init();
  storyCarousel.init();
  badgingCarouselSection.init();
  productHotspot.init();
  productUpsell.init();
  featureBlogSection.init();
  pageModal.init();
  productCompare.init();
  emailOptInSection();

  handleRedirect();
});

Sentry.init({
  debug: false,
  dsn: env.SENTRY_DSN,
  environment: env.SENTRY_ENVIRONMENT,
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: env.SENTRY_TARGETS,
    }),
    new Sentry.Replay({
      blockAllMedia: false,
      inlineImages: true,
      maskAllInputs: false,
      maskAllText: false,
    }),
  ],
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  tracesSampleRate: 0.1,
});
